<template>
    <!-- <v-footer padless absolute color="orange darken-1 pt-6" height="auto" app class="white--text"> -->
   <v-footer padless absolute app height="auto" >

    <v-card flat outlined  tile class=" text-center pb-0" width="100%" min-height="280px" color="light-blue darken-4">

      <v-card-text class="white--text">
        <v-row no-gutters>
        </v-row>
        <!-- <v-divider></v-divider> -->
      </v-card-text>
      <v-card-text class="pt-0 pb-0 text-h7 img-box white--text">
        <v-row class="mt-1" ></v-row>
        <v-row class="py-6">
          <!-- <v-col cols="6" class="d-flex align-center justify-end pb-6 pr-0">
            <v-img src="@/assets/img/aozora-mrk.png" height="40px" max-width="40px" aspect-ratio="1.4" contain></v-img>
          </v-col> -->
          <v-col cols="12" class="d-flex align-center justify-center">
            <p class="font-family-rogo text-kanji-logo">登記託</p>
          </v-col>
          
        </v-row>

        <v-row align-content="center" justify="start" no-gutters dense class="text-body-2">
          <v-col cols="12" sm="12" md="2" lg="2" xl="2"></v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            
            <!-- <p class="link-bar" @click="trnsHelp(KbnCdTejyun)">ご利用ガイド</p>   -->
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            <p class="link-bar" @click="trnsHelp(KbnCdPlan)">対応登記・料金プラン</p>
            
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            <p class="link-bar" @click="trnsPoricyView(kbnTypPolicy, KbnCdCompany)">運営法人</p>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            <p class="link-bar" @click="trnsPoricyView(kbnTypPolicy, KbnCdService)">利用規約</p>
            <!-- <v-img src="@/assets/img/touki-mngr-title.png" width="32%" height="auto"  @click="trnsToukiMngr()"></v-img> -->
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2"></v-col>
        </v-row>


        <v-row align-content="center" justify="start" no-gutters dense class="text-body-2">
          <v-col cols="12" sm="12" md="2" lg="2" xl="2"></v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            <!-- <p class="link-bar" @click="trnsHelp(KbnCdPlan)">対応登記・料金プラン</p> -->
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            <p class="link-bar" @click="trnsHelp(KbnCdQA)">よくある質問</p>
            
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            <p class="link-bar" @click="trnsPoricyView(kbnTypPolicy, KbnCdPrivacy)">個人情報の取り扱い</p>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2">
            <!-- <v-img src="@/assets/img/honnin-sev-title.png" width="40%" height="auto"  @click="trnsVFTqs()"></v-img> -->
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2"></v-col>
        </v-row>

        
        <v-row align-content="center" justify="center" no-gutters dense class="text-body-2">
          <v-col cols="12" sm="12" md="2" lg="2" xl="2"></v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2"></v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            
            <p class="link-bar" @click="trnsInquiry()">お問い合わせ・ご相談</p>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="d-flex align-center justify-start">
            <p class="link-bar" @click="trnsPoricyView(kbnTypPolicy, KbnCdBusiness)">特定商取引法に基づく表記</p>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2">
            <!-- <v-img src="@/assets/img/honnin-sev-title.png" width="40%" height="auto"  @click="trnsVFTqs()"></v-img> -->
            <!-- <v-img src="@/assets/img/touki-mngr-title.png" width="32%" height="auto"  @click="trnsToukiMngr()"></v-img> -->
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2" xl="2"></v-col>
        </v-row>
        <v-row class="mt-4" style="height: 2vh;"></v-row>
      </v-card-text>
      
      <!-- <v-img src="@/assets/img/teacher.png" class="img-box-right-down"></v-img> -->
      <v-row align-content="center" justify="start" no-gutters dense>
        <v-col cols="12" class="d-flex align-center justify-start text-caption text-md-subtitle-1 pl-6">
          <p>Copyright 2023 aozora All Rights Reserved</p>
        </v-col>
      </v-row>
    </v-card>

      <!-- お問い合わせ -->
    <!-- <template v-if="contactUsDspFlg">
      <v-card color="primary" flat  min-width="100%" class="mb-0">
        <v-card-subtitle class="white--text">お電話でのお問い合わせはこちら<br/>営業時間 9:00 ～ 17:00 (定休日：土日祝日)</v-card-subtitle>
        <v-card-text class="white--text">
          <v-row >
            <v-col cols="2">
              <v-icon class="info-box-keyframe">mdi-phone-classic</v-icon>
            </v-col>
            <v-col cols="10" style="margin-bottom: 0px !important;">
              <p class="text-h5">058-251-1233</p>
            </v-col>
          </v-row>
          <v-row >
            <v-col cols="12">
              <div style="info-box">
                <v-btn rounded x-large color="green darken-1 " class="white--text" @click="trnsInquiry()">
                    <v-icon>mdi-email-outline</v-icon>
                    &nbsp;お問い合わせ・ご相談
                </v-btn>
                <v-img src="@/assets/img/tqsman-big.png" class="info-box-right"></v-img>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template> -->
    <template v-if="contactUsDspFlg">
      <v-card color="primary" flat  min-width="100%" class="mb-0">
        <v-card-title class="black--text ">お問い合わせはこちら</v-card-title>
        <v-card-text class="white--text">
          <v-row >
            <v-col cols="12">
              <div style="info-box">
                <v-btn rounded x-large color="green darken-1 " class="white--text" @click="trnsInquiry()">
                    <v-icon>mdi-email-outline</v-icon>
                    &nbsp;お問い合わせ・ご相談
                </v-btn>
                <v-img src="@/assets/img/tqsman-big.png" class="info-box-right"></v-img>
              </div>
            </v-col>
          </v-row>
          <v-card-subtitle class="black--text">お気軽にご相談ください。</v-card-subtitle>
          <v-row class="mt-8" style="height: 30px;"></v-row>
        </v-card-text>
      </v-card>
    </template>

  </v-footer>

</template>

<script>
import Utils from "../common/utils";
export default {
  props: ["contactUsDspFlg", "moveTopDspPos", "propSrcScreenId"],
  data() {
    return {
      
      kbnTypHelp: "100",
      KbnCdQA: "0",
      KbnCdTejyun: "1",
      KbnCdPlan: "2",

      kbnTypPolicy: "200",
      KbnCdService: "0",
      KbnCdPrivacy: "1",
      KbnCdBusiness: "2",
      KbnCdCompany: "3",
    };
  },
  computed: {
    sourceScreenUrl() {
      return this.propSrcScreenId;
    },
  },
  methods: {

    trnsToukiMngr() {
      this.$router.push(this.$router.resolve({ name: "MTA100" }).href);
    },
    /**
     * 本人確認申請へ遷移
     */
    trnsVFTqs() {
      this.$router.push(this.$router.resolve({ name: "VFA100" }).href);
    },
    /**
     * 問い合わせ画面へ遷移
     */
    trnsInquiry() {
      // let routeData = this.$router.resolve({
      //   name: 'PSS400', 
      // });
      // window.open(routeData.href, '_blank', 'noreferrer');
      // this.$router.push( this.$router.resolve({ name: 'PSS400', params: {srcScreenId: this.propSrcScreenId} }).href);
      let transViewPath = this.$router.resolve({ name: "PSS400", params: {srcScreenId: "PSS100"} }).href;
      // window.open(transViewPath, '_blank', 'noreferrer');
      this.$router.push(transViewPath).catch(()=>{});
    },
    /**
     * 利用規約画面へ遷移
     */
    trnsPoricyView(typ, cd) {
      // let routeData = this.$router.resolve({
      //   name: 'PSS200', 
      //   params:{ kbnTyp:typ, KbnCd:cd}
      // });
      // window.open(routeData.href, '_blank', 'noreferrer');
      let transViewPath = this.$router.resolve({ name: "PSS200", params: {kbnTyp:typ, KbnCd:cd, srcScreenId: "PSS100"} }).href;
      this.$router.push(transViewPath).catch(()=>{});
    },
    /**
     * ヘルプ画面へ遷移
     */
    trnsHelp(kbnCdVal) {
      // 引数チェック
      if (Utils.isNullOrEmptyOrUunDef(kbnCdVal)) {
        return;
      }
      
      // // 別タブ表示
      // let routeData = this.$router.resolve({
      //   name: "PSS300",
      //   params: { kbnTyp: this.kbnTypHelp, KbnCd: kbnCdVal },
      // });
      // window.open(routeData.href, "_blank", 'noreferrer');
      let transViewPath = this.$router.resolve({ name: "PSS300", params: {kbnTyp: this.kbnTypHelp, KbnCd: kbnCdVal, srcScreenId: "PSS100"} }).href;
      this.$router.push(transViewPath).catch(()=>{});
    },
  },

};
</script>

<style scoped>
.font-family-rogo {
  position: relative;
  font-family: "HGP行書体", 'ヒラギノ明朝 Pro W3', 'Hiragino Mincho Pro', '游明朝','Yu Mincho', '游明朝体', 'YuMincho','ＭＳ Ｐ明朝', 'MS PMincho', serif;
  font-weight: bold;
  font-size: 3.3em;
}
.info-box {
  position: relative;
  height: auto;
  margin: 0 auto;
}
.info-box-right {
  position: absolute; 
  top: 80%;
  right: 20px;
  transform: translateY(-80%);
  width: 100px; 
  height: auto; 
}
.info-box-keyframe {
  animation: loop 50s -25s linear infinite;
  animation-name: anim_s;
  transform: rotate(30deg);
  animation-duration: 5s;
}

.link-bar {
  position: relative;
  display: inline-block;
  transition: .3s;
}
.link-bar::after {
  position: absolute;
  bottom: 0;
  left: 0;
  content: '';
  width: 0;
  height: 2px;
  background-color: #EF6C00;
  transition: .3s;
}
.link-bar:hover::after {
  width: 100%;
}

.img-box {
  position: relative;
  height: auto;
  margin: 0 auto;
}
.img-box-right-down {
  position: absolute; 
  top: 92%;
  right: 10px;
  transform: translateY(-90%);
  width: 240px; 
  height: auto; 
}

@keyframes anim_s {
  50% {
      transform: rotate(-30deg);
  }
  100% {
      transform: rotate(30deg);
  }
}
</style>